import {useSelector} from 'react-redux'
import {getIsNoDatesSearch} from 'modules/search/selectors'
import {useGetHotelPriceInsightsFAQQuery} from 'modules/seoApi'
import {getHotelPriceInsightsFAQParams} from 'modules/seoApi/selectors'

/**
 * Price insights FAQs for the dateless AP, already rendered with the hotel's prices.
 * SSR preloads the same query, so all consumers share one request and cache
 * entry. `faqs` is undefined while loading and when the feature does not apply.
 */
export const usePriceInsightsFAQ = (hotelId: string | undefined) => {
  const isNoDatesSearch = useSelector(getIsNoDatesSearch)

  const params = useSelector(state =>
    getHotelPriceInsightsFAQParams(state, hotelId ?? '')
  )
  const {faqs} = useGetHotelPriceInsightsFAQQuery(params, {
    selectFromResult: result => ({faqs: result?.data?.faqs}),
    skip: !hotelId || !isNoDatesSearch
  })

  return {faqs}
}
